export interface BlockedSlot {
  date: string;
  time: string;
}

const STORAGE_KEY = 'noventi_blocked_slots';

type BookingStorage = Pick<Storage, 'getItem' | 'setItem'>;

export function readBlockedSlots(storage: BookingStorage): BlockedSlot[] {
  try {
    const parsed: unknown = JSON.parse(storage.getItem(STORAGE_KEY) || '[]');
    if (!Array.isArray(parsed)) return [];
    const unique = new Map<string, BlockedSlot>();
    for (const item of parsed) {
      if (
        item &&
        typeof item === 'object' &&
        typeof item.date === 'string' &&
        /^\d{4}-\d{2}-\d{2}$/.test(item.date) &&
        typeof item.time === 'string' &&
        /^\d{2}:\d{2}$/.test(item.time)
      ) {
        unique.set(`${item.date}:${item.time}`, { date: item.date, time: item.time });
      }
    }
    return [...unique.values()];
  } catch {
    return [];
  }
}

export function writeBlockedSlots(storage: BookingStorage, slots: BlockedSlot[]) {
  storage.setItem(STORAGE_KEY, JSON.stringify(slots));
}

export function reserveBookingSlot(
  storage: BookingStorage,
  slot: BlockedSlot
): { reserved: boolean; slots: BlockedSlot[] } {
  const slots = readBlockedSlots(storage);
  const taken = slots.some((item) => item.date === slot.date && item.time === slot.time);
  if (taken) return { reserved: false, slots };
  const reservedSlots = [...slots, slot];
  writeBlockedSlots(storage, reservedSlots);
  return { reserved: true, slots: reservedSlots };
}
